// extracted by mini-css-extract-plugin
module.exports = {"loader":"RecentlyViewedProfiles_loader__41S2K"};